import { getItem } from "@/utils/storage.js";
import responseHandler from "@/utils/responseHandler.js";
import api from "@/utils/api.js";

export const getVestingSchedule = async ({ commit, dispatch }) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.getVestingSchedule();
    const { data } = response.data;
    commit("SET_VESTING_SCHEDULE", data);
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    dispatch("setLoading", false, { root: true });
    return error;
  }
};

export const updateVestingSchedule = async ({ dispatch }, payload) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.updateVestingSchedule(payload);
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    dispatch("setLoading", false, { root: true });
    return error;
  }
};

export const createEsopToken = async ({ dispatch }, payload) => {
  const id = getItem("org_details")._id;
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.createEsopToken(payload);
    dispatch("organisationModule/getOrganisationProfile", id, { root: true });
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    dispatch("setLoading", false, { root: true });
    return error;
  }
};

export const updateEsopToken = async ({ dispatch }, payload) => {
  const id = getItem("org_details")._id;
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.updateEsopToken(payload);
    dispatch("organisationModule/getOrganisationProfile", id, { root: true });
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    dispatch("setLoading", false, { root: true });
    return error;
  }
};

export const getEsopToken = async ({ dispatch, commit }) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.getEsopToken();
    const { data } = response.data;
    commit("SET_ESOP_TOKEN", data);
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    dispatch("setLoading", false, { root: true });
    return error;
  }
};

export const createVestingSchedule = async ({ dispatch }, payload) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.createVestingSchedule(payload);
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    dispatch("setLoading", false, { root: true });
    return error;
  }
};

export const getEsoOverviewData = async ({ dispatch, commit }, payload) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.getEsoOverviewData(payload);
    const { data } = response.data;
    commit("SET_ESO_OVERVIEW", data);
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    dispatch("setLoading", false, { root: true });
    return error;
  }
};

export const InviteEmployee = async ({ dispatch }, payload) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.InviteEmployee(payload);
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    dispatch("setLoading", false, { root: true });
    return error;
  }
};
export const updateEmployeeInvite = async ({ dispatch }, { payload, id }) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.updateEmployeeInvite({ payload, id });
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    dispatch("setLoading", false, { root: true });
    return error;
  }
};

export const getEmployeeInvites = async ({ dispatch, commit }, query) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.getEmployeeInvites(query);
    const { data } = response.data;
    const employees = data.invites;
    const page = data.page;
    const pages = data.pages;
    commit("SET_EMPLOYEE_INVITES", employees);
    commit("SET_INVITES_PAGE_INFO", { page, pages });
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    dispatch("setLoading", false, { root: true });
    responseHandler.handleError(error);
    return error;
  }
};

export const getAllEmployeeInvites = async ({ dispatch, commit }, query) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.getEmployeeInvites(query);
    const { data } = response.data;
    const employees = data.invites;
    commit("SET_ALL_EMPLOYEE_INVITES", employees);
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    dispatch("setLoading", false, { root: true });
    responseHandler.handleError(error);
    return error;
  }
};
export const getEmployeeInvite = async ({ dispatch, commit }, id) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.getEmployeeInvite(id);
    const { data } = response.data;
    const employee = data;
    commit("SET_EMPLOYEE_INVITE", employee);
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    responseHandler.handleError(error);
    return error;
  }
};

export const cancelInvite = async ({ dispatch }, id) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.cancelInvite(id);
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    dispatch("setLoading", false, { root: true });
    responseHandler.handleError(error);
    return error;
  }
};
export const terminateEmployeeEsop = async ({ dispatch }, id) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.terminateEmployeeEsop(id);
    dispatch("setLoading", false, { root: true });
    return response;
  } catch (error) {
    dispatch("setLoading", false, { root: true });
    responseHandler.handleError(error);
    return error;
  }
};

export const getEsopOrder = async ({ commit }, id) => {
  try {
    const response = await api.getEsopOrder(id);
    const { orders } = response.data.data;
    commit("SET_ESOP_ORDER", orders);
    return true;
  } catch (error) {
    responseHandler.handleError(error);
    return false;
  }
};

export const buyEsop = async ({ state, dispatch }, payload) => {
  dispatch("setLoading", true, { root: true });
  try {
    const response = await api.buyEsop(payload);
    dispatch("getEsopOrder", state.esopToken._id);
    dispatch("setLoading", false, { root: true });
    return true;
  } catch (error) {
    dispatch("setLoading", false, { root: true });
    responseHandler.handleError(error);
    return false;
  }
};
